import { create } from 'zustand'

export type SuggestedViewsUIState = {
  isSuggestedViewsDrawerOpen: boolean
  setIsSuggestedViewsDrawerOpen: (open: boolean) => void
  resetSuggestedViewsUI: () => void
}

const initialState = {
  isSuggestedViewsDrawerOpen: false,
}

export const useSuggestedViewsUIStore = create<SuggestedViewsUIState>()(
  (set) => ({
    ...initialState,

    setIsSuggestedViewsDrawerOpen: (open) =>
      set({ isSuggestedViewsDrawerOpen: open }),

    resetSuggestedViewsUI: () => set(initialState),
  }),
)
